import { LocalDate } from '@spa-frontend/date-lib';
import { getAge } from '../get-age';

export const ageError = 'message.error.age.invalid';
export const DEFAULT_MINIMUM_AGE = 18;

export const ageValidator = (
    getAgeInfo: () =>
        | {
              dateOfBirth: LocalDate;
              timezone: string;
              minimumAge?: number;
          }
        | undefined
) => () => {
    const ageInfo = getAgeInfo();

    if (!ageInfo) {
        return false;
    }

    const { minimumAge = DEFAULT_MINIMUM_AGE, dateOfBirth, timezone } = ageInfo;
    const age = getAge(dateOfBirth, timezone);

    return age < minimumAge ? ageError : false;
};
